export enum RestaurantsSorting {
  CREATED_ASC = 'CREATED_ASC',
  CREATED_DESC = 'CREATED_DESC',
  RATING_ASC = 'RATING_ASC',
  RATING_DESC = 'RATING_DESC',
  NAME_ASC = 'NAME_ASC',
  NAME_DESC = 'NAME_DESC',
  RANDOM_IN_3_HRS = 'RANDOM_IN_3_HRS',
  RANDOM_IN_6_HRS = 'RANDOM_IN_6_HRS',
  RANDOM_IN_12_HRS = 'RANDOM_IN_12_HRS',
  RANDOM_IN_24_HRS = 'RANDOM_IN_24_HRS'
}

export enum RestaurantsRandomSortingType {
  RANDOM = 'RANDOM',
  BY_RATING_PROBABILITIES_0_5 = 'BY_RATING_PROBABILITIES_0_5',
  BY_RATING_PROBABILITIES_1 = 'BY_RATING_PROBABILITIES_1',
  BY_RATING_PROBABILITIES_1_5 = 'BY_RATING_PROBABILITIES_1_5',
  BY_RATING_PROBABILITIES_2 = 'BY_RATING_PROBABILITIES_2',
  BY_RATING_PROBABILITIES_2_5 = 'BY_RATING_PROBABILITIES_2_5',
  BY_RATING_PROBABILITIES_3 = 'BY_RATING_PROBABILITIES_3',
  BY_RATING_PROBABILITIES_3_5 = 'BY_RATING_PROBABILITIES_3_5',
  BY_RATING_PROBABILITIES_4 = 'BY_RATING_PROBABILITIES_4',
  BY_RATING_PROBABILITIES_4_5 = 'BY_RATING_PROBABILITIES_4_5',
  BY_RATING_PROBABILITIES_5 = 'BY_RATING_PROBABILITIES_5'
}

export interface SettingsResponse {
  baseDeliveryPrice: number;
  restaurantPerOrderChargePercentage: number;
  driverPerOrderChargePercentage: number;
  clientsSupportChatUrl: string;
  driversSupportChatUrl: string;
  restaurantsSupportChatUrl: string;
  adminEmail: string;
  shouldDriversConfirmOrderCode: boolean;
  canClientCancelOrder: boolean;
  restaurantsSortingForClients: RestaurantsSorting;
  restaurantsRandomSortingType: RestaurantsRandomSortingType;
  minAndroidVersion: string | null;
  minIOSVersion: string | null;
  usePolygons: boolean;
  allowDriversAcceptOrderWithLowBalance: boolean;
  useAutoAcceptOrderRules: boolean;
  restaurantsForceClosed: boolean;
  bannersEnabled: boolean;
  isRestaurantCategoriesEnabled: boolean;
  restaurantsMinRatingToShow: number;
  useDriverGroupsForOrderVisibility: boolean;
  slotCancellationWindowHours: number;
}

export interface UpdateSettingsRequest {
  baseDeliveryPrice: number;
  restaurantPerOrderChargePercentage: number;
  driverPerOrderChargePercentage: number;
  clientsSupportChatUrl: string;
  driversSupportChatUrl: string;
  restaurantsSupportChatUrl: string;
  adminEmail: string;
  shouldDriversConfirmOrderCode: boolean;
  canClientCancelOrder: boolean;
  restaurantsSortingForClients: RestaurantsSorting;
  restaurantsRandomSortingType: RestaurantsRandomSortingType;
  minAndroidVersion: string | null;
  minIOSVersion: string | null;
  usePolygons: boolean;
  allowDriversAcceptOrderWithLowBalance: boolean;
  useAutoAcceptOrderRules: boolean;
  restaurantsForceClosed: boolean;
  bannersEnabled: boolean;
  isRestaurantCategoriesEnabled: boolean;
  restaurantsMinRatingToShow: number;
  useDriverGroupsForOrderVisibility: boolean;
  slotCancellationWindowHours: number;
}

export interface DriverGroupVisibilityGroup {
  id: number;
  name: string;
  ordersVisible: boolean;
}

export interface DriverGroupVisibilityResponse {
  driverGroups: DriverGroupVisibilityGroup[];
}

export interface UpdateDriverGroupVisibilityRequest {
  visibleDriverGroupIds: number[];
}
